import React, { Component} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardTitle,
  CardText,
  Button
} from "reactstrap";
import {Link} from 'react-router-dom';
import "./how-to-apply.css";

export default class index extends Component {
  render() {
    return (
      <div className="how-to-apply">
        <Row className="section-headline justify-content-center">
          <Col className="how-headline" xs={{ size: 10 }} sm={{ size: 5 }}>
          <h1 className=" mt-5 center-h1">How To Apply</h1>

            <hr className="how-underline" />
          </Col>
        </Row>
       <Container>
       <Row className="justify-content-center">
                <Col sm={{ size: 3 }}>
                  <Card className="clear-card">
                    <CardImg
                      className="icon-size"
                      top
                      width="100%"
                      src="img/submit-icon-v2.png"
                      alt="Card image cap"
                    />
                    <h5 className="icon-num-size">1</h5>

                    <CardTitle>
                      <h3 className="how-apply-sub-header ">
                        Submit Interest Application
                      </h3>
                    </CardTitle>
                    <CardText className="apply-text-sec apply-steps">
                      Tell us about yourself and your goals for your career so we can get an idea of where you’re looking to move towards.
                    </CardText>
                  </Card>
                </Col>

                <Col sm={{ size: 3 }}>
                <Card className="clear-card">
                    <CardImg
                      className="icon-size"
                      top
                      width="100%"
                      src="img/review-icon-v2.png"
                      alt="Card image cap"
                    />
                    <h5 className="icon-num-size">2</h5>
                    <CardTitle>
                    <h3 className="how-apply-sub-header">
                        Application Reviewed
                      </h3>
                    </CardTitle>
                    <CardText className="apply-text-sec apply-steps">
                      Once you submit your application, our student advisors will review over it and reach out to you on next steps.
                    </CardText>
                  </Card>
                </Col>

                <Col sm={{ size: 3 }}>
                <Card className="clear-card">
                    <CardImg
                      className="icon-size"
                      top
                      width="100%"
                      src="img/mentors-for-success-icon-v2.png"
                      alt="Card image cap"
                    />
                    <h5 className="icon-num-size">3</h5>

                    <CardTitle>
                    <h3 className="how-apply-sub-header">
                        Meet with Student Advisor
                      </h3>
                    </CardTitle>
                    <CardText className="apply-text-sec apply-steps">
                      After initial review, you’ll meet face-to-face with one of our student advisors to go over your application, discuss in detail, and answer any extra questions you may have about enrollment.
                    </CardText>
                  </Card>
                </Col>

                <Col sm={{ size: 3 }}>
                <Card className="clear-card">
                    <CardImg
                      className="icon-size"
                      top
                      width="100%"
                      src="img/enroll-icon-v2.png"
                      alt="Card image cap"
                    />

                    <h5 className="icon-num-size">4</h5>

                    <CardTitle>
                    <h3 className="how-apply-sub-header">Enroll in Course</h3>
                    </CardTitle>
                    <CardText className="apply-text-sec apply-steps">
                      If the program is a good fit for you, the student advisor will provide you with the necessary paperwork to get you enrolled so you can start the path towards your future.
                    </CardText>
                  </Card>
                </Col>
              </Row>
           <Link to='/apply-now'>
           <Button className="course-hero-start1">
                  Start Application
                </Button>

           </Link>
         
           
          
          
       </Container>
      </div>
    );
  }
}
